import React, { useContext, useEffect } from 'react';
import SrollTop from './components/common/ScrollTop';
import Aos from 'aos';
import Header from './components/header';
import Sidebar from './components/sidebar';
import Footer from './components/common/Footer';
import { useRoutes } from 'react-router-dom';
import { OwnerRoutes } from './routes/OwnerRoutes';
import { AuthContext } from './context/AuthProvider';
import { refreshToken, sportalokaClient } from './api/sportaloka-client';
import Cookies from 'js-cookie';
import { AdminRoutes } from './routes/AdminRoutes';

function App() {
  const auth = useContext(AuthContext);
  const userType = auth[0]?.user_profile?.type;
  const appRoutes = useRoutes(userType == 'TENANT_OWNER' ? OwnerRoutes : AdminRoutes);
  const [state, dispatch] = useContext(AuthContext);

  useEffect(() => {
    Aos.init({
      duration: 1200,
      once: true
    });
  }, []);

  sportalokaClient.interceptors.request.use((config) => {
    const access_token = Cookies.get('access_token');
    config.headers.Authorization = 'Bearer ' + access_token;
    return config;
  });

  sportalokaClient.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response.data.code == '100105' || error.response.data.code === '100203') {
        window.location.replace(`${process.env.REACT_APP_PUBLIC_WEB_URL}/auth/signin`);
        return Promise.reject(error);
      }
      if (error.response.data.code === '100102' || error.response.data.code === '100103') {
        try {
          const refresh_token = Cookies.get('refresh_token') ?? '';
          const session_id = Cookies.get('session_id') ?? '';
          const response = await refreshToken(refresh_token, session_id);
          const responseData = response.data.data;
          dispatch({
            type: 'SET_FROM_COOKIE',
            payload: {
              access_token: responseData.access_token ? responseData.access_token : '',
              refresh_token: responseData.refresh_token ? responseData.refresh_token : '',
              session_id: responseData.session_id ? responseData.user.session_id : '',
              user_profile: responseData.user ? responseData.user : null
            }
          });
          error.config.headers['Authorization'] = 'Bearer ' + responseData.access_token;
          return sportalokaClient(error.config);
        } catch (refreshTokenError) {
          const refreshTokenErrorStatus = refreshTokenError.response.status;
          if (refreshTokenErrorStatus === 401) {
            window.location.replace(`${process.env.REACT_APP_PUBLIC_WEB_URL}/auth/signin`);
          }
          return Promise.reject(refreshTokenError);
        }
      }
      return Promise.reject(error);
    }
  );

  return (
    <div className="App">
      {state.init_loading ? (
        <div
          className="d-flex justify-content-center flex-column align-items-center"
          style={{ height: '100vh', fontSize: 20, fontWeight: '700' }}>
          <img style={{ height: 50 }} src="/img/general/SP2_logo_black.png" alt="logo icon" />
          <p className="text-dark">Memuat...</p>
        </div>
      ) : (
        <div>
          <div className="header-margin"></div>
          <Header />
          <div className="dashboard">
            <div className="dashboard__sidebar bg-white scroll-bar-1">
              <Sidebar role={userType} />
            </div>

            <div className="dashboard__main">
              <div className="dashboard__content bg-light-2 pb-60">{appRoutes}</div>
              <Footer />
            </div>
          </div>
          <SrollTop />
        </div>
      )}
    </div>
  );
}

export default App;
